'use client';

/**
 * Forked from apps/users/ui/components/TwoFactorAuthentication/TwoFactorAuthentication.tsx solely
 * to wrap the CFR-local TwoFactorAuthenticationContext (uilib alerts) instead of the shared one
 * (uikit-alert). TwoFactorAuthenticationModal/Form below are the original, unmodified, shared
 * components — they don't touch AlertManager. App Router migration: do not replace this fork
 * with the shared apps/users component (see TwoFactorAuthenticationContext.tsx in this folder).
 */
import React, { useEffect } from 'react';
import { useSessionContext } from '@users/session/SessionContext';
import TwoFactorAuthenticationModal from '@users/two-factor-authentication/TwoFactorAuthenticationModal';
import TwoFactorAuthenticationContext from '@/creditflowresearch/infrastructure/bootstrap/TwoFactorAuthentication/TwoFactorAuthenticationContext';

interface IProps {
  children: React.ReactNode,
}

const TwoFactorAuthentication = ({ children }: IProps) => {
  const {
    isTwoFactorAuthenticationRequired,
    setIsTwoFactorAuthenticationRequired,
    logout,
    currentUser,
    session,
  } = useSessionContext();

  useEffect(() => {
    if (!currentUser && !session) {
      setIsTwoFactorAuthenticationRequired(false);
    }
  }, [currentUser, session]);

  const handleModalClose = () => {
    logout({ autoLogout: true, redirect: true });
  };

  const handleSuccess = () => {
    setIsTwoFactorAuthenticationRequired(false);
  };

  return isTwoFactorAuthenticationRequired() ? (
    <TwoFactorAuthenticationModal
      isVisible
      onClose={ handleModalClose }
      successCallback={ handleSuccess }
      showOverlay={ false }
      currentUser={ currentUser }
    />
  ) : children;
};

export default (props: React.ComponentProps<typeof TwoFactorAuthentication>) => (
  <TwoFactorAuthenticationContext>
    <TwoFactorAuthentication { ...props } />
  </TwoFactorAuthenticationContext>
);
